import script from "./additional.vue?vue&type=script&lang=ts&setup=true"
export * from "./additional.vue?vue&type=script&lang=ts&setup=true"

import "./additional.vue?vue&type=style&index=0&id=4b356abf&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b356abf"]])

export default __exports__